import { NgModule } from '@angular/core';
import { provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { BrowserModule } from "@angular/platform-browser";
import { PeopleService } from "../../services/people/people.service";
import { PeopleComponent } from "./people.component";
import { TabsModule } from 'ngx-bootstrap/tabs';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import {
  ButtonModule,
  InputsModule,
  TagsModule,
  EmptyStateSearchModule,
  EmptyStateModule,
  CardsModule,
  AvatarModule,
  CheckboxModule
} from '@xref/xref-lib';
import { AvatarIconModule } from 'src/app/components/avatar-icon/avatar-icon.module';
import { AppPaginationModule } from 'src/app/components/pagination/pagination.module';
import { SortV2Module } from 'src/app/components/sort-v2/sort-v2.module';
import { FooterModule } from 'src/app/components/footer/footer.module';
import { SearchCoreModule } from 'src/app/components/search-core/search-core.module';
import { SearchCoreChipDisplayModule } from 'src/app/components/search-core-chip-display/search-core-chip-display.module';
import { FilterV2Module } from 'src/app/components/filter-v2/filter-v2.module';
import { LoaderModule } from "src/app/components/loader/loader.module";
import { NoDataModule } from "src/app/components/no-data/no-data.module";
import { AllPeopleComponent } from '../../components/all-people/all-people.component';
import { TalentPoolComponent } from '../../components/talent-pool/talent-pool.component';
import { SendXrefButtonModule } from "../../components/send-xref-button/send-xref-button.module";
import { RouterModule } from '@angular/router';
import { TooltipEllipsifyModule } from 'src/app/directives/tooltip-ellipsify/tooltip-ellipsify.module';
import { PeopleHelpModalModule } from '../../components/people-help-modal/people-help-modal.module';
import { ReportHelpModalModule } from 'src/app/components/report-help-modal/report-help-modal.module';
import { i18nPipeModule } from 'src/app/pipes/i18n-convertor-pipe/i18n-convertor.module';

@NgModule({ declarations: [
        PeopleComponent,
        AllPeopleComponent,
        TalentPoolComponent,
    ],
    exports: [PeopleComponent], imports: [BrowserModule,
        RouterModule,
        SendXrefButtonModule,
        AppPaginationModule,
        AvatarIconModule,
        SortV2Module,
        FooterModule,
        SearchCoreModule,
        CheckboxModule,
        SearchCoreChipDisplayModule,
        FilterV2Module,
        PeopleHelpModalModule,
        ReportHelpModalModule,
        LoaderModule,
        NoDataModule,
        TabsModule.forRoot(),
        TooltipModule.forRoot(),
        TooltipEllipsifyModule,
        i18nPipeModule,
        InputsModule,
        ButtonModule,
        TagsModule,
        EmptyStateSearchModule,
        CardsModule,
        AvatarModule,
        EmptyStateModule], providers: [
        PeopleService,
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class PeopleModule {
}
